import styled from "styled-components";

export const Container = styled.div`
  width: 300px;
  height: auto;
  min-height: 100px;
  max-height: 200px;
  overflow-y: auto;
  background-color: white;
  padding: 1rem 1rem;
  position: absolute;
  display: flex;
  top: 40px;
  left: 0;
  flex-direction: column;
  -webkit-box-shadow: 0px 0px 15px -2px rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 15px -2px rgba(0, 0, 0, 0.2);
  padding-bottom: 1rem;
  border-radius: 0 0 5px 5px;

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #a5a5a5;
    border-radius: 10px;
    border: 3px solid #ffffff;
  }

  .wrapper-relative {
    display: flex;
    flex-direction: column;
    width: auto;
    height: auto;
    position: relative;
  }

  .wrapper-absolute {
    position: absolute;
    top: -2px;
    right: -10px;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    .icon-close {
      width: 10px;
      height: 10px;
    }
  }

  span {
    font-family: "Open Sans", sans-serif;
    font-size: 1.2rem;
    margin: 0.5rem 1rem;

    :hover {
      color: ${({ theme }) => theme.colors.background};
      font-weight: bold;
    }
  }
`;
